import React, { useRef, useEffect, useState } from 'react'
import {
    BrowserRouter as Router,
    Link,
    useLocation,
    useNavigate
} from "react-router-dom";

import useForm from "../../services/useForm";
import validate from "../../services/validations/changePasswordFormValidationRules";

import { Header } from '../../components/Header'
import { Footer } from '../../components/Footer'

export const ChangePassword = () => {
    const history = useNavigate();
    const location = useLocation();

    const {
        values,
        errors,
        handleChange,
        handleSubmit,
    } = useForm(changePassword, validate);

    const [success, setSuccess] = useState(false);
    const [hasErrors, setHasErrors] = useState(false);
    const [errorMessages, setErrorMessages] = useState('');

    function showDefaultError(){
        setErrorMessages('Ha ocurrido un error inesperado, por favor vuelva a intentarlo más tarde.')
        setHasErrors(true);
    }

    function goSignIn() {
        window.location = '/signIn'
    }

    function changePassword() {
        let params = new URLSearchParams(location.search);
        let userId = params.get("uid");
        let token = params.get("token");

        if (!!token) {
            fetch(process.env.REACT_APP_API_URL + "/auth/changePassword", {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(
                    {
                        userId : userId,
                        token: token,
                        password: values.password
                    })
            })
            .then((response) => {
                if (response.ok) {
                    setSuccess(true);
                }
                else {
                    if (response.status === 500) {
                        showDefaultError();
                    }
                    else {
                        response.json().then(data => {
                            data.errors.forEach((error) => {
                                if (error === 'UserNotFound' || error === 'TokenInvalid') {
                                    setErrorMessages('El enlace no es válido o ha caducado. Por favor, vuelva a solicitar el "Recuperar contraseña" o contáctenos en soporte@gamarreando.es')
                                    setHasErrors(true);
                                }
                                else {
                                    showDefaultError();
                                }
                            })
                        });
                    }
                }
            })
            .catch(function (error) {
                showDefaultError();
            });
        }
        else {
            history.push("/");
        }
    };

    return (
        <>
           <Header />
            {!success &&
                <div id="sign-in-dialog" className="zoom-anim-dialog">
                    <div className="small-dialog-header">
                        <h3>Cambia tu contraseña</h3>
                    </div>
                    <br />
                    {hasErrors &&
                        <div className="notification error closeable">
                            <p>{errorMessages}</p>
                        </div>
                    }
                    <div className="sign-in-form style-1">
                    <form  onSubmit={handleSubmit} method="post" className="login">
                        <p className="form-row form-row-wide">
                            <label for="password">Ingrese la nueva contraseña:
                                <i className="im im-icon-Lock-2"></i>
                                <input className="input-text" type="password" name="password" id="password" onChange={handleChange} value={values.password || ''} />
                            </label>
                            {errors.password && (
                                    <p className="help is-danger">{errors.password}</p>
                            )}
                        </p>
                        <p className="form-row form-row-wide">
                            <label for="rePassword">Reingrese la nueva contraseña:
                                <i className="im im-icon-Lock-2"></i>
                                <input className="input-text" type="password" name="rePassword" id="rePassword" onChange={handleChange} value={values.rePassword || ''} />
                            </label>
                            {errors.rePassword && (
                                    <p className="help is-danger">{errors.rePassword}</p>
                            )}
                        </p>
                        <div className="form-row">
                            <input type="submit" className="button border margin-top-5" name="login" value="Iniciar sesión" />
                        </div>
                    </form>
                </div>
                </div>
            }
            { success &&
                <div id="sign-in-dialog" className="zoom-anim-dialog">
                    <div className="row">
                        <div className="col-md-12">

                            <h3>Contraseña cambiada correctamente</h3>

                            <div className="notification success closeable">
                                <h4>Intente loguearse ahora con la nueva contraseña.</h4>
                            </div>

                        </div>
                        <div className="col-md-12">
                            <button className="button" onClick={goSignIn}>Iniciar Sesión</button>
                        </div>
                    </div>
                </div>
            }
            <Footer />
        </>
    )
}